import {
  Box,
  Button,
  Center,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Flex,
  Heading,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { Link, Outlet } from "react-router-dom";
import { NavLink } from "./NavLink";
import React, { useRef } from "react";

export const Layout = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef<HTMLButtonElement>(null);

  return (
    <Box w="100%">
      <Button
        ref={btnRef}
        fontFamily="Starim"
        fontSize="35"
        textAlign="center"
        onClick={onOpen}
        w="100%"
        p={16}
      >
        Stuccoed Lamb
      </Button>
      <Drawer
        placement="top"
        isOpen={isOpen}
        onClose={onClose}
        size={"full"}
        closeOnEsc
      >
        <DrawerHeader fontFamily="Starim">Stuccoed Lamb</DrawerHeader>
        <DrawerContent>
          <DrawerCloseButton
            width="100%"
            inset="0"
            position="relative"
            p={0}
            height="15vh"
            maxHeight="150px"
            color="purple"
            backgroundColor="#f3f3f3ff"
          />
          <Center height="100vh" w="100%">
            <Flex
              flexDir="column"
              fontFamily="Starim"
              fontSize="25px"
              gap={4}
              w="full"
              alignItems="center"
            >
              <NavLink linkText="Gallery" navTo="/" onClick={onClose} />
              <NavLink
                linkText="Wiggly Paint"
                navTo="/wiggly-paint"
                onClick={onClose}
              />
              <NavLink linkText="Poetry" navTo="/poetry" onClick={onClose} />
              <NavLink
                linkText="Animated GIFS"
                navTo="/animated-gifs"
                onClick={onClose}
              />
            </Flex>
          </Center>
        </DrawerContent>
      </Drawer>
      <Box width="100%" minHeight="600px" pt={10} pb={200}>
        <Outlet />
      </Box>
    </Box>
  );
};
